var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-28.124 -110)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(28.124 110)",
    fill: "#ff6f00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-business-man-157513",
    transform: "translate(20.337 107.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M30.027,14.957c-.2-4.388-3.873-4.352-4.234-4.337-.361-.014-4.032-.051-4.234,4.337,0,0-.714,6.568,4.205,6.619h.058C30.741,21.525,30.027,14.957,30.027,14.957Zm-4.488-2.675a6.8,6.8,0,0,0-2.184,1.938.27.27,0,0,1-.483-.213,2.57,2.57,0,0,1,2.52-2.231A.27.27,0,0,1,25.539,12.282Zm9.31,15.733a7.219,7.219,0,0,1-.2,1.885,17.287,17.287,0,0,1-8.823,2.144l0-.125-.011.125A17.287,17.287,0,0,1,17,29.9a7.219,7.219,0,0,1-.2-1.885h0c-.068-.965.014-2.914,1.7-3.343A14.046,14.046,0,0,0,22.611,22.8l1.706,5.4,1-2.829c-1.915-2.672.507-2.567.507-2.567s2.422-.1.507,2.568l1,2.827L29.033,22.8a14.046,14.046,0,0,0,4.106,1.872c1.69.43,1.77,2.381,1.7,3.345Z",
    fill: "#fffbf8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGroom);
export default __webpack_public_path__ + "static/media/profileGroom.675477d0fa1431538ebc5ed3d10bdf8b.svg";
export { ForwardRef as ReactComponent };